// ** MUI Imports
import { lighten, darken } from "@mui/material/styles";

// ** Type Import
import { OwnerStateThemeType } from "../";

const Alert = () => {
  return {
    MuiAlert: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          borderRadius: 5,
          color: theme.palette.text.secondary,
          "& .MuiAlertTitle-root": {
            marginBottom: theme.spacing(1.6),
          },
          "& a": {
            fontWeight: 500,
            color: "inherit",
          },
        }),
        standardSuccess: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor: theme.palette.success.light,
        }),
        standardInfo: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor: theme.palette.info.light,
        }),
        standardWarning: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor: theme.palette.warning.light,
        }),
        standardError: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor: theme.palette.error.light,
        }),
        outlinedSuccess: ({ theme }: OwnerStateThemeType) => ({}),
        outlinedInfo: ({ theme }: OwnerStateThemeType) => ({}),
        outlinedWarning: ({ theme }: OwnerStateThemeType) => ({}),
        outlinedError: ({ theme }: OwnerStateThemeType) => ({}),
        filled: ({ theme }: OwnerStateThemeType) => ({
          fontWeight: 400,
          color: theme.palette.common.white,
        }),
      },
    },
  };
};

export default Alert;
